module.exports = __webpack_public_path__ + "images/629defaff47a20f5034aef8b04083fbd9.svg";